import { render, staticRenderFns } from "./SettingsFooter.vue?vue&type=template&id=3e3e8525&scoped=true&"
import script from "./SettingsFooter.vue?vue&type=script&lang=js&"
export * from "./SettingsFooter.vue?vue&type=script&lang=js&"
import style0 from "./SettingsFooter.vue?vue&type=style&index=0&id=3e3e8525&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3e8525",
  null
  
)

export default component.exports